import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { RouterEvent, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Select, Store } from '@ngxs/store';
import { IUser } from 'src/app/models/IUser';
import { UserState } from 'src/app/store/user.state';
import { NavMenuService } from 'src/app/services/nav-menu/nav-menu.service';

@Component({
    selector: 'admin',
    templateUrl: './admin.component.html',
    styles: [],
    standalone: false
})

export class AdminComponent implements OnInit, OnDestroy {
    @Select(UserState.user) user$: Observable<IUser>;
    private userSubscription: Subscription;
    private rolesSubscription: Subscription;
    private disableDropdownSubscription: Subscription;
    isUserShow = false;
    isDisabled: string;
    currDate = new Date();
    private roles: Array<string> = [];
    isActive = label => (label == 'reporting') ? this.router.url.includes('reports') : this.router.url.includes(label);
    isFacilitator: boolean;
    isAdmin: boolean;
    event$;
    displayAppeVersion: boolean = false;

    constructor(private auth: AuthenticationService, private router: Router, private navMenuService: NavMenuService,
        private store: Store
    ) {
        this.isDisabled = (this.isFacilitatorPortalRoute() ? 'facilitator' : 'admin');
    }

    disabledRoleNav() {
        this.event$ = this.router.events.pipe(
            filter((e: any): e is RouterEvent => e instanceof NavigationEnd))
            .subscribe(() => {
                const onFacilitatorPortal = this.isFacilitatorPortalRoute();
                this.isDisabled = (onFacilitatorPortal ? 'facilitator' : 'admin');
                this.navMenuService.isFacilitatorView(onFacilitatorPortal);
            });
    }

    ngOnInit() {
        this.userSubscription = this.store?.select(UserState.user)
            .subscribe(
                (user) => {
                    this.displayAppeVersion = user?.operator;
                }); // Get operator state.
        this.applyRoles(this.auth.getUserRoles());
        this.rolesSubscription = this.auth.roles$.subscribe((roles) => {
            this.applyRoles(roles);
        });
        this.disabledRoleNav();
        this.disableDropdownSubscription = this.navMenuService.disableDropdownMenu$.subscribe((response: string) => {
            this.isDisabled = response;
            this.navMenuService.isFacilitatorView(this.isFacilitatorPortalRoute());
        });
    }

    /** Router.url can lag the browser URL on cold load; align side nav with both. */
    private isFacilitatorPortalRoute(): boolean {
        const routerPath = (this.router.url || '').split(/[?#]/)[0];
        const browserPath = typeof window !== 'undefined' ? window.location.pathname || '' : '';
        return (
            routerPath.startsWith('/admin/programs-external') ||
            browserPath.startsWith('/admin/programs-external')
        );
    }

    private applyRoles(roles: string[]): void {
        this.roles = roles;
        this.isFacilitator = roles.includes('facilitator') || roles.includes('admin');
        this.isAdmin = roles.includes('admin');
        this.navMenuService.refreshNavbar();
        this.navMenuService.isFacilitatorView(this.isFacilitatorPortalRoute());
    }

    toggleUserRole() {
        this.isUserShow = !this.isUserShow;
    }

    private routAdmin(value: string): void {
        if (value.includes('admin')) {
            this.router.navigate(['admin']);
            this.navMenuService.isFacilitatorView(false);
            this.isUserShow = false;
            this.isDisabled = 'admin';
        }
        else if (value.includes('journey')) {
            this.router.navigate(['journey/home']);
            this.isUserShow = false;
            this.navMenuService.isFacilitatorView(false);
        }
        else if (value.includes('facilitator')) {
            this.navMenuService.isFacilitatorView(true);
            this.router.navigate(['admin/programs-external']);
            this.isUserShow = false;
            this.isDisabled = 'facilitator';
        }
        else if (value.includes('signOut')) {
            localStorage.clear();
            sessionStorage.clear();
            this.auth.signOut();
        }
    }

    private showHideAdmin(): boolean {
        let result = true;
        if (this.roles.includes('admin') && this.router.url.includes('admin')) {
            result = false;
        }
        return result;
    }

    private showHideFacilitator(): boolean {
        let result = false;   //In case of showing facilitator in future, change result=true
        if (this.roles.includes('admin') && this.router.url.includes('facilitator')) {
            result = false;
        }
        return result;
    }

    private showHideParticipant(): boolean {
        let result = true;
        if (this.roles.includes('admin') && this.router.url.includes('journey')) {
            result = false;
        }
        return result;
    }

    ngOnDestroy() {
        this.event$?.unsubscribe();
        this.userSubscription.unsubscribe();
        this.rolesSubscription?.unsubscribe();
        this.disableDropdownSubscription?.unsubscribe();
    }
}
